const colors = {
  scoreChart: {
    english: [ "#a6579d", "#de4997"],
    math: ["#dc5850", "#e66c46"],
    reading: ["#95d6ef", "#53b7c2"],
    science: ["#c5da8c", "#84b44d"],
  }
}

export default colors


// WEBPACK FOOTER //
// ./src/helpers/assessment/colors.js